import React from "react";
import {useState,useEffect} from "react";
import {useLocation,useNavigate} from "react-router-dom";
import Grid from "@mui/material/Grid";
import LinearProgress from "@mui/material/LinearProgress";
import {Box} from "@mui/system";
import {Button} from "primereact/button";
import {InputText} from "primereact/inputtext";
import {Dialog} from "primereact/dialog";
import {confirmDialog} from "primereact/confirmdialog";
import {ConfirmDialog} from "primereact/confirmdialog";
import {BlockUI} from "primereact/blockui";
import {DataTable} from "primereact/datatable";
import {Column} from "primereact/column";
import Message from "../Helpers/Message.js";
import {fetch_url_post,get_anaf_details} from "../../Sources/js/app.js";

let oper="";

let defaultInputValues={
	id: null,
	name: "",
	reg_no: "",
	rc: "",
	address: "",
	email: "",
	contact_person: "",
	phone: "",
	observations: "",
	filter_providers: "",
	TVA: "",
};

let defaultDataValues={
	providersList: [],
};

let defaultDialogValues={
	openAddEdit: false,
	titleAddEdit: "",
	openNotFound: false,
	titleNotFound: "",
};

let defaultInputError={
	disableSave: false,
	errorText: "",
};

let initialValue={};

const Providers = (props) => {

	var timerId=null;
	defaultInputValues.id=(props.providerId?props.providerId:null);

	const [inputValues, setInputValues] = useState(defaultInputValues);
	const [dataValues, setDataValues] = useState(defaultDataValues);
	const [messageText, setMessageText] = useState(null);
	const [dataOk, setDataOk] = useState(false);
	const [dialogValues, setDialogValues] = useState(defaultDialogValues);
	const [inputError, setInputError] = useState(defaultInputError);	
	const [blockScreen, setBlockScreen] = useState(false);
	const [providersList, setProvidersList] = useState([]);
    const location = useLocation();
    const navigate = useNavigate();

	const handleChange = evt => {
		const {name, value} = evt.target;
		if(name==="name") {
			let found=false;
			if(dataValues.providersList.length>0) {
				dataValues.providersList.forEach(element => {
					if((value.toUpperCase()===element.name.toUpperCase())&&((value!==initialValue.name)||(!initialValue))) {
						found=true;
					}
				});
			}
			let tmp={
				disableSave: found,
				errorText: (found===true?"Exista deja un furnizor cu acest nume!":""),
			}
			setInputError(tmp);
		}
		if(name==="reg_no") {
			let found=false;
			if(dataValues.providersList.length>0) {
				dataValues.providersList.forEach(element => {
					if((value.toUpperCase()===element.reg_no.toUpperCase())&&((value!==initialValue.reg_no)||(!initialValue))) {
						found=true;
					}
				});
			}
			let tmp={
				disableSave: found,
				errorText: (found===true?"Exista deja un furnizor cu acest CUI!":""),
			}
			setInputError(tmp);
		}
		if(name==="filter_providers") {
			setProvidersList(dataValues.providersList.filter((provider)=>((provider.name.toLowerCase().indexOf(value.toLowerCase())>-1))||(value==="")));
		}
		setInputValues({...inputValues,[name]:value});
	}

	const handleChecked = (evt) => {
		const {name, checked} = evt.target;
		if(checked) {
			setInputValues({...inputValues,[name]:1});			
		}else{
			setInputValues({...inputValues,[name]:0});			
		}
	}	

	const handleButton = (evt,what,elementData) => {
		if(what==="add") {
			setInputValues(defaultInputValues);
			setDialogValues({...dialogValues,openAddEdit: true,titleAddEdit: "Adaugare furnizor nou"});
			setInputError(defaultInputError);
		}
		if(what==="edit") {
			elementData.filter_providers=inputValues.filter_providers;
			initialValue=elementData;
			setInputValues(elementData);
			setDialogValues({...dialogValues,openAddEdit: true,titleAddEdit: "Editare furnizor "+elementData.name});
			setInputError(defaultInputError);
		}
		if(what==="delete") {
			let url="deleteProvider";
			url+="?session_id="+props.session.sessId;
			oper="delete";
			let data={
				id: elementData.id,
			};
			timerId=fetch_url_post(url,data,success_handler,fail_handler,wait_handler);
		}
		if(what==="save") {
			document.querySelectorAll("input").forEach((element)=>element.classList.remove("required_input_error"));
			if(inputValues.name==="") {
				setMessageText("Eroare: Completati campul nume!");				
				document.getElementById("name").classList.add("required_input_error");
				return false;
			}
			if(inputValues.address==="") {
				setMessageText("Eroare: Completati campul adresa!");				
				document.getElementById("address").classList.add("required_input_error");
				return false;
			}
			let url="saveProvider";
			url+="?session_id="+props.session.sessId;
			oper="save";
			let data={...inputValues};
			timerId=fetch_url_post(url,data,success_handler,fail_handler,wait_handler);
		}
		if(what==="get_anaf_details") {
			oper="get_anaf_details";
			document.querySelectorAll("input").forEach((element)=>element.classList.remove("required_input_error"));
			if(inputValues.reg_no.length<7) {
				setMessageText("Eroare: Completati corect campul C.U.I!");				
				document.getElementById("reg_no").classList.add("required_input_error");
				return false;
			}
			timerId=get_anaf_details(inputValues.reg_no,success_handler,fail_handler,wait_handler,props.session.sessId);
		}
	}

	const success_handler = (result) => {
		setBlockScreen(false);
		if(timerId) {
			clearTimeout(timerId);
			setMessageText("");
		}
		if(result.ok===0) {
			setMessageText("Eroare: "+result.error);
			return false;
		}
		if(result.is_auth===0) {
			navigate("/login");			
			return false;
		}
		if(result.message) {
			setMessageText(result.message);			
		}
		if((oper==="get")||(oper==="save")||(oper==="delete")) {
			setDialogValues(defaultDialogValues);
			setDataValues({...dataValues,providersList:(result.providersList?result.providersList:[])});
			setProvidersList(result.providersList?result.providersList.filter((provider)=>((provider.name.toLowerCase().indexOf(inputValues.filter_providers.toLowerCase())>-1))||(inputValues.filter_providers==="")):[]);
            if(!dataOk) {
                setDataOk(true);
            }
			oper="";
		}
		if(oper==="get_anaf_details") {
			if(result.message==="SUCCESS") {
				if(result.notFound[0]) {
					setDialogValues({...dialogValues,openNotFound: true,titleNotFound: "CUI inexistent"});
				}else{
					let name=result.found[0].date_generale.denumire;
					let address=result.found[0].date_generale.adresa;
					let rc=result.found[0].date_generale.nrRegCom;
					let phone=result.found[0].date_generale.telefon;
					let TVA=result.found[0].inregistrare_scop_Tva.scpTVA;
					let observations=(result.found[0].stare_inactiv.statusInactivi?"ATENTIE!!! societatea este inactiva":"");
					setInputValues({...inputValues,name: name,address: address,rc:rc,phone:phone,TVA:TVA,observations:observations});
				}
			}else{
				setMessageText("Eroare de comunicatie cu ANAF! Va rugam reincercati!");
			}
			oper="";
		}
	}

	const fail_handler = () => {
		setBlockScreen(false);
		if(timerId) {
			clearTimeout(timerId);
		}
		if(oper==="get_anaf_details") {
			setMessageText("Eroare: Verificati CUI-ul introdus!");
		}else{
			setMessageText("Eroare de conexiune. Va rugam sa incercati mai tarziu!");
		}
	}

	const wait_handler = () => {
		setBlockScreen(true);
		setMessageText("Operatiunea este in curs...");
	}

	useEffect(() => {
		if(props.session.sessId) {
			oper="get";
			let url="getProviders";
			url+="?session_id="+props.session.sessId;
			let data={};
			fetch_url_post(url,data,success_handler,fail_handler);
		}else{
			navigate("/login");
		}
	},[props.session.sessId]);

	const addEditDialog = () => {
		return(
			<Dialog header={dialogValues.titleAddEdit} visible={true} onHide={(evt)=>setDialogValues({...dialogValues,openAddEdit:false})} className="responsive-dialog-med">
				<Grid container spacing={1} style={{"paddingTop":"12px","maxHeight":"72vh"}}>
					<Grid item xs={12} sm={12} md={4} lg={6} className="field padding-min">
						<label htmlFor="name">Nume*</label>
						<InputText name="name" id="name" style={{"width":"100%"}} value={inputValues.name} onChange={(evt) => handleChange(evt)}/>
					</Grid>
					<Grid item xs={12} sm={12} md={4} lg={3} className="field padding-min">
						<label htmlFor="reg_no">CUI furnizor*&nbsp;&nbsp;&nbsp;</label>
						<InputText name="reg_no" id="reg_no" style={{"width":"78.5%","float":"left"}} value={inputValues.reg_no} onChange={(evt) => handleChange(evt)}/>
						<Button icon="pi pi-external-link" className="p-button-sm p-button-raised" style={{"width":"21%","float":"right"}} onClick={(evt) => handleButton(evt,"get_anaf_details")}/>
					</Grid>
					<Grid item xs={12} sm={12} md={4} lg={3} className="field padding-min">
						<label htmlFor="rc">RegCom</label>
						<InputText name="rc" id="rc" style={{"width":"100%"}} value={inputValues.rc} onChange={(evt) => handleChange(evt)}/>
					</Grid>
					<Grid item xs={12} sm={12} md={12} lg={12} className="field padding-min">
						<label htmlFor="address">Adresa*</label>
						<InputText name="address" id="address" style={{"width":"100%"}} value={inputValues.address} onChange={(evt) => handleChange(evt)}/>
					</Grid>
					<Grid item xs={12} sm={12} md={4} lg={4} className="field padding-min">
						<label htmlFor="contact_person">Persoana de contact</label>
						<InputText name="contact_person" id="contact_person" style={{"width":"100%"}} value={inputValues.contact_person} onChange={(evt) => handleChange(evt)}/>
					</Grid>
					<Grid item xs={12} sm={12} md={4} lg={4} className="field padding-min">
						<label htmlFor="email">Email</label>
						<InputText name="email" id="email" style={{"width":"100%"}} value={inputValues.email} onChange={(evt) => handleChange(evt)}/>
					</Grid>
					<Grid item xs={12} sm={12} md={4} lg={4} className="field padding-min">
						<label htmlFor="phone">Telefon</label>
						<InputText name="phone" id="phone" style={{"width":"100%"}} value={inputValues.phone} onChange={(evt) => handleChange(evt)}/>
					</Grid>
					<Grid item xs={12} sm={12} md={12} lg={12} className="field padding-min">
						<label htmlFor="observations">Observatii</label>
						<InputText name="observations" id="observations" style={{"width":"100%"}} value={inputValues.observations} onChange={(evt) => handleChange(evt)}/>
					</Grid>
					<Grid item xs={12} sm={12} md={12} lg={7} style={{"textAlign":"left","marginTop":"21px"}}>
						<div style={{"color":"#FF0000","fontWeight":"600","paddingTop":"0px"}}>
							{inputError.errorText}
						</div>
					</Grid>
					<Grid item xs={12} sm={12} md={12} lg={5} style={{"textAlign":"right","marginTop":"12px"}}>
						<Button label="Salveaza" icon="pi pi-check-circle" className="p-button-sm p-button-success p-button-raised" style={{"marginRight":"6px"}} onClick={(evt) => handleButton(evt,"save")} disabled={inputError.disableSave}/>
						<Button label="Inchide" icon="pi pi-times" className="p-button-sm p-button-danger p-button-raised" onClick={(evt)=>setDialogValues({...dialogValues,openAddEdit:false})}/>
					</Grid>
				</Grid>
			</Dialog>
		);
	}

	const notFoundDialog = () => {
		return(
			<Dialog header={dialogValues.titleNotFound} visible={true} onHide={(evt)=>setDialogValues({...dialogValues,openNotFound:false})} className="responsive-dialog-small">
				<Grid container spacing={1} style={{"paddingTop":"12px"}}>
					<Grid item xs={12} sm={12} md={12} lg={12} className="field padding-min">
						<p style={{"fontWeight":"600","color":"#FF0000"}}>Codul unic de identificare nu a fost gasit pe site-ul ANAF!</p>
					</Grid>
					<Grid item xs={12} sm={12} md={12} lg={12} style={{"textAlign":"right","marginTop":"12px"}}>
						<Button label="Inchide" icon="pi pi-times" className="p-button-sm p-button-danger p-button-raised" onClick={(evt)=>setDialogValues({...dialogValues,openNotFound:false})}/>
					</Grid>
				</Grid>
			</Dialog>
		);
	}

	const tableColTemplate = (row_data,column) => {
		if(column.field==="buttons") {
			return(
				<span>
					<Button label="Editare" icon="pi pi-pencil" tooltip="Editeaza furnizor" className="p-button-sm p-button-raised" style={{"marginRight":"3px"}} onClick={(evt) => handleButton(evt,"edit",row_data)}/>
					<Button label="Stergere" icon="pi pi-trash" tooltip="Sterge furnizor" className="p-button-sm p-button-raised p-button-danger" onClick={(evt) => confirm(evt,"delete",row_data)}/>
				</span>
			);
		}
	}

	const confirm = (evt,what,elementData) => {
		if(what==="delete") {
			confirmDialog({
				message: "Sigur doriti stergerea?",
				header: "Confirmare stergere",
				icon: "pi pi-exclamation-triangle",
				accept: () => handleButton(evt,what,elementData),
				reject: () => null,
			});
		}
	}

	if(dataOk) {
		return(
			<BlockUI blocked={blockScreen} fullScreen>
				<div>
					<Grid container spacing={1} style={{}}>
						<Grid item xs={12} sm={4} md={4} lg={3} xl={3} className="field padding-med">
							<InputText name="filter_providers" id="filter_providers" style={{"width":"100%"}} value={inputValues.filter_providers} placeholder="Cauta furnizor..." onChange={(evt) => handleChange(evt)}/>							
						</Grid>						
						<Grid item xs={12} sm={4} md={4} lg={6} xl={6} className="field padding-med text-left">
							<h6 style={{"marginTop":"9px","color":"#000000"}}>{providersList.length} {(((providersList.length>1)||(providersList.length===0))?" inregistrari gasite.":" inregistrare gasita.")}</h6>
						</Grid>						
						<Grid item xs={12} sm={4} md={4} lg={3} xl={3} className="field padding-med text-right">
							<Button label="Adauga furnizor nou" icon="pi pi-plus-circle" className="p-button-sm p-button-primary p-button-raised" style={{}} onClick={(evt) => {handleButton(evt,"add")}}/>
						</Grid>						
					</Grid>
					<Box sx={{ display: { xs: "none", sm: "none", md: "block", lg: "block", xl: "block" } }}>
						<div className="card">
							<DataTable
								value={providersList}
								scrollable
								scrollHeight="60vh"
								style={{"minHeight":"63vh"}}
								scrollDirection="both"
								stripedRows
								resizableColumns
								columnResizeMode="fit"
								responsiveLayout="stack"
								emptyMessage="Nu exista inregistrari"
							>
								<Column field="name" header="Nume" style={{"flexGrow":"1","flexBasis":"120px"}} sortable></Column>
								<Column field="contact_person" header="Persoana de contact" style={{"flexGrow":"1","flexBasis":"90px"}}></Column>
								<Column field="email" header="Email" style={{"flexGrow":"1","flexBasis":"130px"}}></Column>
								<Column field="phone" header="Telefon" style={{"flexGrow":"1","flexBasis":"20px"}}></Column>
								<Column field="reg_date_parsed" header="Data introducerii" style={{"flexGrow":"1","flexBasis":"20px"}} sortable></Column>
								<Column field="buttons" header="" style={{"flexGrow":"0","flexBasis":"195px"}} body={tableColTemplate}></Column>
							</DataTable>
						</div>
					</Box>
					<Box sx={{ display: { xs: "block", sm: "block", md: "none", lg: "none", xl: "none" } }}>

					</Box>
				</div>
				<ConfirmDialog />
				{messageText && <Message text={messageText} closeHandler={()=>setMessageText(null)}/>}
				{dialogValues.openAddEdit && addEditDialog()}
				{dialogValues.openNotFound && notFoundDialog()}
            </BlockUI>
		);
	}else{
		return(
			<React.Fragment>
				<LinearProgress />
				{messageText && <Message text={messageText} closeHandler={()=>setMessageText(null)}/>}
			</React.Fragment>
		);		
	}
};

export default Providers;


